import { defineMessages } from 'react-intl-next';

export default defineMessages({
	helpButtonLabel: {
		id: 'dev-agents.app.in-product-help.help-button-label',
		defaultMessage: 'Help',
		description: 'Label for the help button in the top navigation',
	},
	slackHelpDescription: {
		id: 'dev-agents.app.in-product-help.slack-help-description',
		defaultMessage: 'Go to #help-boysenberry in Slack',
		description: 'Description for the Slack help channel link',
	},
	askForHelpLink: {
		id: 'dev-agents.app.in-product-help.ask-for-help-link',
		defaultMessage: 'Ask for help or give feedback',
		description: 'Text for the link to ask for help or give feedback',
	},
	aboutLink: {
		id: 'dev-agents.app.in-product-help.about-link',
		defaultMessage: 'About',
		description: 'Text for the About link in the footer',
	},
	termsOfUseLink: {
		id: 'dev-agents.app.in-product-help.terms-of-use-link',
		defaultMessage: 'Terms of Use',
		description: 'Text for the Terms of Use link in the footer',
	},
	privacyPolicyLink: {
		id: 'dev-agents.app.in-product-help.privacy-policy-link',
		defaultMessage: 'Privacy Policy',
		description: 'Text for the Privacy Policy link in the footer',
	},
});
